import React from 'react'
import { useSelector } from 'react-redux'

import bookSelectors from 'store/selectors/booking'
import Select from './Select'

const PriceGroupField = (props) => {
  
  const formConfig = useSelector(bookSelectors.slotFormConfig)

  const options = Object
    .keys(formConfig.prices || {})
    .filter(field => field != 'default')
    .map(field => {
      return {
        title: field,
        value: field,
      }
    })

  const item = Object.assign({}, props.items, {
    options,
  })

  return (
    <Select
      { ...props }
      item={ item }
    />
  )
}

export default PriceGroupField